export default __webpack_public_path__ + "static/media/7minfitness_11@3x.4bd03671.jpg";